import { render, staticRenderFns } from "./Costs.vue?vue&type=template&id=6490cae8&scoped=true"
import script from "./Costs.vue?vue&type=script&lang=js"
export * from "./Costs.vue?vue&type=script&lang=js"
import style0 from "./Costs.vue?vue&type=style&index=0&id=6490cae8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6490cae8",
  null
  
)

export default component.exports